const conformitySigns = {
  keymark_with_vdi: 'Keymark and VDI',
  keymark_only: 'Keymark',
  vdi_only: 'VDI'
}

export default conformitySigns
